 export class Brand {

brand_id?: number;
  name?: string;
  profile?: string;
  sef_name?: string;
  keywords?: string;
  logo?: string;
  phone?: string;
  fax?: string;
  email?: string;
  website?: string;
  listing_cat_id?: number;
  brand_id__?: number;
  is_active?: string;
  created?: string;
  updated?: string;
  created_by?: number;
  updated_by?: number;
  is_represented?: string;
  address?: string;
  main_listing?: string;
  address_1?: string;
  address_2?: string;
  suburb?: string;
  state?: string;
  postcode?: string;
  country?: string;
  custom_report_pdf?: string;
  report_logo?: string;
  report_cover_bg?: string;
  report_general_bg?: string;
  report_colour_base?: string;


  brand_type_id?

/*
  brand_id
  name
  profile
  sef_name
  keywords
  logo
  phone
  fax
  email
  website
  listing_cat_id
  brand_id__
  is_active
  created
  updated
  created_by
  updated_by
  is_represented
  address
  main_listing
  address_1
  address_2
  suburb
  state
  postcode
  country
  custom_report_pdf
  report_logo
  report_cover_bg
  report_general_bg
  report_colour_base

*/

  }
